import React from 'react';
import Swal from 'sweetalert2';
import $ from 'jquery';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { currencyFormat } from '../../js/Functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faAt, faCalendarAlt, faCalendarCheck, faDollarSign, faHashtag, faHistory, faPercentage, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        id_facturacion: '',
        fecha_pago_soporte: '',
        fecha_pago_bitacora: '',
        estado_recaudo: '',
        id_departamento: '',
        id_municipio: '',
        id_contribuyente: '',
        periodo_factura: '',
        consecutivo_fact: '',
        liq_vencidas: '',
        valor_liq_vencidas: '',
        id_tipo_facturacion: '',
        tipo_facturacion: '',
        tarifa: '',
        valor_tarifa: '',
        valor_factura: '',
        nota_fiducia: '',
        fecha_fiducia: '',
        fecha_aplicacion: '',
        valor_recaudo: '',
        saldo_fecha: '',
        contribuyentes: [],
        departamentosMunc: [],
        municipiosMunc: [],
        periodos: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const { id_facturacion, fecha_pago_soporte, fecha_pago_bitacora, estado_recaudo, id_departamento,
                id_municipio, id_contribuyente, nota_fiducia, fecha_fiducia, fecha_aplicacion, valor_recaudo, saldo_fecha } = this.state;
        var errores = [];
        if (!fecha_pago_soporte) { errores.push("error_fecha_pago_soporte"); }
        if (!fecha_pago_bitacora) { errores.push("error_fecha_pago_bitacora"); }
        if (!estado_recaudo) { errores.push("error_estado_recaudo"); }
        if (!id_departamento) { errores.push("error_id_departamento"); }
        if (!id_municipio) { errores.push("error_id_municipio"); }
        if (!id_contribuyente) { errores.push("error_id_contribuyente"); }
        if (!nota_fiducia) { errores.push("error_nota_fiducia"); }
        if (!fecha_fiducia) { errores.push("error_fecha_fiducia"); }
        if (!fecha_aplicacion) { errores.push("error_fecha_aplicacion"); }
        if (!valor_recaudo) { errores.push("error_valor_recaudo"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        var datosEnviar = {
            id_facturacion: id_facturacion,
            fecha_pago_soporte: fecha_pago_soporte,
            fecha_pago_bitacora: fecha_pago_bitacora,
            estado_recaudo: estado_recaudo,
            id_departamento: id_departamento,
            id_municipio: id_municipio,
            id_contribuyente: id_contribuyente,
            nota_fiducia: nota_fiducia,
            fecha_fiducia: fecha_fiducia,
            fecha_aplicacion: fecha_aplicacion,
            valor_recaudo: valor_recaudo,
            id_usuario: window.localStorage.getItem('idusuario')
        }
        Swal.showLoading();
        authAxios.post("reca_municipio/registrar", datosEnviar)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (datosRespuesta.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Recaudo Municipio!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.props.history.push("/MasterRecaMunicipio");
                } else {
                    Swal.close();
                    Swal.fire(
                        'Recaudo Municipio!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    cargarMunicipios() {
        var id_departamento = document.getElementById('id_departamento').value;
        this.setState({ municipiosMunc: [], periodos: [] });
        Swal.showLoading();
        authAxios.get("municipios_visitas/buscardepartamento/" + id_departamento)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, municipiosMunc: datosRespuesta.data, load: '',
                                periodo_factura: '',
                                id_facturacion: '',
                                consecutivo_fact: '',
                                liq_vencidas: '',
                                valor_liq_vencidas: '',
                                id_tipo_facturacion: '',
                                tipo_facturacion: '',
                                tarifa: '',
                                valor_tarifa: '',
                                valor_factura: ''
                });
                document.getElementById("id_facturacion").value = '';
                document.getElementById("periodo_factura").value = '';
                document.getElementById("consecutivo_fact").value = '';
                document.getElementById("liq_vencidas").value = '';
                document.getElementById("valor_liq_vencidas").value = '';
                document.getElementById("id_tipo_facturacion").value = '';
                document.getElementById("tipo_facturacion").value = '';
                document.getElementById("tarifa").value = '';
                document.getElementById("valor_tarifa").value = '';
                document.getElementById("valor_factura").value = '';
                Swal.close();
            })
            .catch(console.log);
    }
    cargarContribuyentes() {
        Swal.showLoading();
        var id_departamento = document.getElementById("id_departamento").value;
        var id_municipio = document.getElementById("id_municipio").value;
        authAxios.get("contribuyentes/contribuyente_munc/" + id_departamento + "/" + id_municipio)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, contribuyentes: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    cargarPeriodos() {
        var id_contribuyente = document.getElementById('id_contribuyente').value;
        var id_departamento = document.getElementById('id_departamento').value;
        var id_municipio = document.getElementById('id_municipio').value;
        this.setState({ periodos: [] });
        Swal.showLoading();
        authAxios.get("fact_municipio/periodos_reca/" + id_contribuyente + "/" + id_departamento + "/" + id_municipio)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, periodos: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    seleccionarPeriodo = (id_facturacion) => {
        Swal.showLoading();
        authAxios.get("fact_municipio/ver/" + id_facturacion)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ periodo_factura: datosRespuesta.data.resultado.PERIODO_FACTURA,
                                id_facturacion: datosRespuesta.data.resultado.ID_FACTURACION,
                                consecutivo_fact: datosRespuesta.data.resultado.CONSECUTIVO_FACT,
                                liq_vencidas: datosRespuesta.data.resultado.NO_LIQ_VENCIDAS,
                                valor_liq_vencidas: datosRespuesta.data.resultado.VALOR_LIQ_VENCIDAS,
                                id_tipo_facturacion: datosRespuesta.data.resultado.ID_TIPO_FACTURACION,
                                tarifa: datosRespuesta.data.resultado.TARIFA,
                                valor_tarifa: datosRespuesta.data.resultado.VALOR_TARIFA,
                                valor_factura: datosRespuesta.data.resultado.VALOR_FACTURA
                            });
                switch (datosRespuesta.data.resultado.ID_TIPO_FACTURACION) {
                    case 1:
                        document.getElementById("tipo_facturacion").value = "CONSUMO";
                        this.setState({ tipo_facturacion: "CONSUMO" });
                        break;
                    case 2:
                        document.getElementById("tipo_facturacion").value = "SALARIOS";
                        this.setState({ tipo_facturacion: "SALARIOS" });
                        break;
                    case 3:
                        document.getElementById("tipo_facturacion").value = "UVT";
                        this.setState({ tipo_facturacion: "UVT" });
                        break;
                    case 4:
                        document.getElementById("tipo_facturacion").value = "COMERCIAL";
                        this.setState({ tipo_facturacion: "COMERCIAL" });
                        break;
                }
                document.getElementById("id_facturacion").value = datosRespuesta.data.resultado.ID_FACTURACION;
                document.getElementById("periodo_factura").value = datosRespuesta.data.resultado.PERIODO_FACTURA;
                document.getElementById("consecutivo_fact").value = datosRespuesta.data.resultado.CONSECUTIVO_FACT;
                document.getElementById("liq_vencidas").value = datosRespuesta.data.resultado.NO_LIQ_VENCIDAS;
                document.getElementById("valor_liq_vencidas").value = datosRespuesta.data.resultado.VALOR_LIQ_VENCIDAS;
                document.getElementById("id_tipo_facturacion").value = datosRespuesta.data.resultado.ID_TIPO_FACTURACION;
                document.getElementById("tarifa").value = datosRespuesta.data.resultado.TARIFA;
                document.getElementById("valor_tarifa").value = datosRespuesta.data.resultado.VALOR_TARIFA;
                document.getElementById("valor_factura").value = datosRespuesta.data.resultado.VALOR_FACTURA;
                Swal.close();
            })
            .catch(console.log);
    }
    calcularSaldoFecha = () => {
        var valor_factura = document.getElementById("valor_factura").value;
        var valor_recaudo = document.getElementById("valor_recaudo").value;
        this.setState({ saldo_fecha : (valor_factura - valor_recaudo) });
        document.getElementById('saldo_fecha').value = (valor_factura - valor_recaudo);
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("departamentos_visitas/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, departamentosMunc: datosRespuesta.data.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { fecha_pago_soporte, fecha_pago_bitacora, estado_recaudo, id_departamento, id_municipio, id_contribuyente,
                id_facturacion, consecutivo_fact, liq_vencidas, valor_liq_vencidas, id_tipo_facturacion, tipo_facturacion,
                tarifa, valor_tarifa, valor_factura, nota_fiducia, fecha_fiducia, fecha_aplicacion, valor_recaudo, periodo_factura,
                saldo_fecha, periodos, contribuyentes, departamentosMunc, municipiosMunc } = this.state;
        return (
            <>
                <div className="content-wrapper">
                    <div className="content">
                        <div className="container-fluid">
                            <br />
                            <div className="card">
                                <div className="card-header text-center">
                                    <b>REGISTRO DE RECAUDO MUNICIPIO</b>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={this.enviarDatos}>
                                        <div className="row">
                                            <div className="col-xl-12">
                                                <div className='row g-3'>
                                                    <div className="col-md-2">
                                                        <input type="hidden" name="id_facturacion" id='id_facturacion' defaultValue={id_facturacion} />
                                                        <input type="hidden" name="id_usuario" id="id_usuario" value={window.localStorage.getItem('idusuario')} />
                                                        <label htmlFor="fecha_pago_soporte">Fecha Pago Soporte</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_pago_soporte" id="fecha_pago_soporte" value={fecha_pago_soporte}
                                                                className={((this.verificarError("error_fecha_pago_soporte")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="FECHA PAGO SOPORTE" aria-describedby="helpId"
                                                                onChange={this.cambioValor}
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Seleccione la Fecha Pago Soporte</small>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="fecha_pago_bitacora">Fecha Pago Bitacora</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_pago_bitacora" id="fecha_pago_bitacora" value={fecha_pago_bitacora}
                                                                className={((this.verificarError("error_fecha_pago_bitacora")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="FECHA PAGO BITACORA" aria-describedby="helpId"
                                                                onChange={this.cambioValor}
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Seleccione la Fecha Pago Bitacora</small>
                                                    </div>
                                                    <div className='col-md-5'></div>
                                                    <div className='col-md-3'>
                                                        <label htmlFor="estado_recaudo">Estado Recaudo</label>
                                                        <select name="estado_recaudo"
                                                            id="estado_recaudo"
                                                            className={((this.verificarError("error_estado_recaudo")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                            onChange={this.cambioValor}>
                                                            <option value="">Seleccione el Estado Recaudo</option>
                                                            <option value="1">ENTREGADO</option>
                                                            <option value="2">PENDIENTE DE ENVÍO</option>
                                                            <option value="3">RECLAMADA</option>
                                                            <option value="4">PAGADA</option>
                                                            <option value="5">PAGO PARCIAL</option>
                                                        </select>
                                                        <small id="helpId" className="invalid-feedback">Seleccione el Estado Recaudo</small>
                                                    </div>
                                                </div>
                                                <hr style={{ marginBottom: 0 }} />
                                                <div style={{ fontSize: 14 }} className="card-header text-center">
                                                    <b>INFORMACIÓN MUNICIPIO / CONTRIBUYENTE</b>
                                                </div>
                                                <div style={{ marginTop: 0 }} className='row g-3'>
                                                    <div className='col-md-3'>
                                                        <label htmlFor="id_departamento">Departamento</label>
                                                        <select name="id_departamento"
                                                            id="id_departamento"
                                                            className={((this.verificarError("error_id_departamento")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                            onChange={e => {
                                                                this.cargarMunicipios(e);
                                                                this.cambioValor(e)
                                                            }}>
                                                            <option value="">Seleccione el Departamento</option>
                                                            {
                                                                departamentosMunc.map((itemDepartamentosMunc) => (
                                                                    <option key={itemDepartamentosMunc.ID_DEPARTAMENTO} value={itemDepartamentosMunc.ID_DEPARTAMENTO}>{itemDepartamentosMunc.NOMBRE}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <small id="helpId" className="invalid-feedback">Seleccione el Departamento</small>
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <label htmlFor="id_municipio">Municipio</label>
                                                        <select name="id_municipio"
                                                            id="id_municipio"
                                                            className={((this.verificarError("error_id_municipio")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                            onChange={e => {
                                                                this.cargarContribuyentes(e);
                                                                this.cambioValor(e)
                                                            }}>
                                                            <option value="">Seleccione el Municipio</option>
                                                            {
                                                                municipiosMunc.map((itemMunicipiosMunc) => (
                                                                    <option key={itemMunicipiosMunc.ID_MUNICIPIO} value={itemMunicipiosMunc.ID_MUNICIPIO}>{itemMunicipiosMunc.NOMBRE}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <small id="helpId" className="invalid-feedback">Seleccione el Municipio</small>
                                                    </div>
                                                    <div className='col-md-5'>
                                                        <label htmlFor="id_contribuyente">Contribuyente</label>
                                                        <select name="id_contribuyente"
                                                            id="id_contribuyente"
                                                            className={((this.verificarError("error_id_contribuyente")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                            onChange={(e) => {
                                                                this.cargarPeriodos(e);
                                                                this.cambioValor(e)
                                                            }}>
                                                            <option value="">Seleccione el Contribuyente</option>
                                                            {
                                                                contribuyentes.map((itemContribuyentes) => (
                                                                    <option key={itemContribuyentes.ID_CONTRIBUYENTE} value={itemContribuyentes.ID_CONTRIBUYENTE}>{itemContribuyentes.NOMBRE}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <small id="helpId" className="invalid-feedback">Seleccione el Contribuyente</small>
                                                    </div>
                                                </div>
                                                <hr style={{ marginBottom: 0 }} />
                                                <div style={{ fontSize: 14 }} className="card-header text-center">
                                                    <b>INFORMACIÓN TIPO FACTURACIÓN / VALORES FACTURA</b>
                                                </div>
                                                <div style={{ marginTop: 0 }} className="row g-3">
                                                    <div className='col-md-2'>
                                                        <label htmlFor="periodos">Periodos</label>
                                                        <div className="btn-group" role="group" aria-label="">
                                                            <button type="button" className="btn btn-primary btn-sm" data-bs-toggle='modal' data-bs-target="#PeriodosRecaModal" slot='end'>
                                                                <FontAwesomeIcon icon={faCalendarCheck} />
                                                            </button>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="periodo_factura" id="periodo_factura" defaultValue={periodo_factura} 
                                                                    className={"form-control form-control-sm"} placeholder="Periodo Factura" aria-describedby="helpId"
                                                                    onChange={this.cambioValor} readOnly />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="consecutivo_fact">Consecutivo Factura</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="consecutivo_fact" id="consecutivo_fact" defaultValue={consecutivo_fact}
                                                                className={"form-control form-control-sm"} placeholder="Consecutivo Fact." aria-describedby="helpId"
                                                                onChange={this.cambioValor} readOnly
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Digite el Consecutivo Factura</small>
                                                    </div>
                                                </div>
                                                <div style={{ marginTop: 0 }} className="row g-3">
                                                    <div className="col-md-2">
                                                        <label htmlFor="liq_vencidas">Liq. Vencidas</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="liq_vencidas" id="liq_vencidas" defaultValue={liq_vencidas}
                                                                className={"form-control form-control-sm"} placeholder="Liq. Vencidas" aria-describedby="helpId"
                                                                onChange={this.cambioValor} readOnly
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Digite las Liq. Vencidas</small>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="valor_liq_vencidas">Valor Liq. Vencidas</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="valor_liq_vencidas" id="valor_liq_vencidas" defaultValue={valor_liq_vencidas}
                                                                className={"form-control form-control-sm"} placeholder="Valor Liq. Vencidas" aria-describedby="helpId"
                                                                onChange={this.cambioValor} readOnly
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Digite el Valor Liq. Vencidas</small>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="tipo_facturacion">Tipo Facturación</label>
                                                        <input type="hidden" name='id_tipo_facturacion' id='id_tipo_facturacion' value={id_tipo_facturacion} />
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="tipo_facturacion" id="tipo_facturacion" defaultValue={tipo_facturacion} 
                                                            className={((this.verificarError("error_tipo_facturacion")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="TIPO FACTURACIÓN" aria-describedby="helpId"
                                                            onChange={this.cambioValor} readOnly
                                                        />
                                                        <small id="helpId" className="invalid-feedback">Digite el Tipo Facturación</small>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="tarifa">Tarifa</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={id_tipo_facturacion === 1 ? faPercentage : faHashtag} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="tarifa" id="tarifa" defaultValue={tarifa}
                                                                className={"form-control form-control-sm"} placeholder="Tarifa" aria-describedby="helpId"
                                                                onChange={this.cambioValor} readOnly
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Digite la Tarifa</small>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="valor_tarifa">Valor Tarifa</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="valor_tarifa" id="valor_tarifa" defaultValue={valor_tarifa}
                                                                className={"form-control form-control-sm"} placeholder="Valor Tarifa" aria-describedby="helpId"
                                                                onChange={this.cambioValor} readOnly
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Digite el Valor Tarifa</small>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="valor_factura">Valor Factura</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="valor_factura" id="valor_factura" defaultValue={valor_factura}
                                                                className={"form-control form-control-sm"} placeholder="Valor Factura" aria-describedby="helpId"
                                                                onChange={this.cambioValor} readOnly
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Digite el Valor Factura</small>
                                                    </div>
                                                </div>
                                                <hr style={{ marginBottom: 0 }} />
                                                <div style={{ fontSize: 14 }} className="card-header text-center">
                                                    <b>INFORMACIÓN RECAUDO</b>
                                                </div>
                                                <div style={{ marginTop: 0 }} className="row g-3">
                                                    <div className='col-xl-12'>
                                                        <div className='row g-3'>
                                                            <div className="col-md-2">
                                                                <label htmlFor="nota_fiducia">Nota Fiducia</label>
                                                                <div className="input-group input-group-sm">
                                                                    <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="nota_fiducia" id="nota_fiducia" value={nota_fiducia}
                                                                        className={((this.verificarError("error_fecha_fiducia")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="NOTA FIDUCIA" aria-describedby="helpId"
                                                                        onChange={this.cambioValor}
                                                                    />
                                                                </div>
                                                                <small id="helpId" className="invalid-feedback">Digite la Nota Fiducia</small>
                                                            </div>
                                                            <div className="col-md-2">
                                                                <label htmlFor="fecha_fiducia">Fecha Fiducia</label>
                                                                <div className="input-group input-group-sm">
                                                                    <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                                    <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_fiducia" id="fecha_fiducia" value={fecha_fiducia}
                                                                        className={((this.verificarError("error_fecha_fiducia")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="FECHA FIDUCIA" aria-describedby="helpId"
                                                                        onChange={this.cambioValor}
                                                                    />
                                                                </div>
                                                                <small id="helpId" className="invalid-feedback">Seleccione la Fecha Fiducia</small>
                                                            </div>
                                                            <div className="col-md-2">
                                                                <label htmlFor="fecha_aplicacion">Fecha Aplicación</label>
                                                                <div className="input-group input-group-sm">
                                                                    <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                                    <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_aplicacion" id="fecha_aplicacion" value={fecha_aplicacion}
                                                                        className={((this.verificarError("error_fecha_aplicacion")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="FECHA APLICACIÓN" aria-describedby="helpId"
                                                                        onChange={this.cambioValor}
                                                                    />
                                                                </div>
                                                                <small id="helpId" className="invalid-feedback">Seleccione la Fecha Aplicación</small>
                                                            </div>
                                                            <div className="col-md-2">
                                                                <label htmlFor="valor_recaudo">Valor Recaudo</label>
                                                                <div className="input-group input-group-sm">
                                                                    <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="valor_recaudo" id="valor_recaudo" value={valor_recaudo}
                                                                        className={((this.verificarError("error_valor_recaudo")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="VALOR RECAUDO" aria-describedby="helpId"
                                                                        onChange={(e) => {
                                                                            this.cambioValor(e);
                                                                            this.calcularSaldoFecha(e);
                                                                        }}
                                                                    />
                                                                </div>
                                                                <small id="helpId" className="invalid-feedback">Digite el Valor Recaudo</small>
                                                            </div>
                                                            <div className='col-md-2'></div>
                                                            <div className="col-md-2">
                                                                <label htmlFor="saldo_fecha">Saldo Fecha</label>
                                                                <div className="input-group input-group-sm">
                                                                    <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                                    <input style={{ textTransform: 'uppercase', textAlign: 'center' }} type="text" name="saldo_fecha" id="saldo_fecha" value={saldo_fecha} readOnly
                                                                        className={((this.verificarError("error_saldo_fecha")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="SALDO FECHA" aria-describedby="helpId"
                                                                    />
                                                                </div>
                                                                <small id="helpId" className="invalid-feedback">Digite el Saldo Fecha</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr />
                                        <div className='row'>
                                            <div className='col-xl-12 text-center'>
                                                <div className="btn-group" role="group" aria-label="">
                                                    <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Crear Reca. Operador de Red</button>&nbsp;&nbsp;
                                                    <Link className="btn btn-danger btn-sm" to={"/MasterRecaMunicipio"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="PeriodosRecaModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="PeriodosRecaModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="PeriodosRecaModalLabel">Periodos Recaudo</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        <table className="table table-hover table-condensed table-sm">
                                            <thead className="thead-inverse">
                                                <tr>
                                                    <th className="align-middle">CONSECUTIVO FACTURA</th>
                                                    <th className="align-middle">PERIODO</th>
                                                    <th className="align-middle">VALOR FACTURA</th>
                                                    <th className="align-middle">ESTADO FACTURA</th>
                                                    <th className="align-middle">ESTADO RECAUDO</th>
                                                    <th className="align-middle">SELECCIONAR</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    periodos.map((itemPeriodos) => (
                                                        <tr key={itemPeriodos.ID_FACTURACION}>
                                                            <td>{itemPeriodos.CONSECUTIVO_FACT}</td>
                                                            <td>{itemPeriodos.PERIODO_FACTURA}</td>
                                                            <td><b>$ </b>{currencyFormat(itemPeriodos.VALOR_FACTURA)}</td>
                                                            {
                                                                (() => {
                                                                    switch (itemPeriodos.ESTADO_FACTURA) {
                                                                        case 1:
                                                                            return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-primary">E</span></td>)
                                                                        case 2:
                                                                            return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-danger">PE</span></td>)
                                                                        case 3:
                                                                            return (<td><span style={{ fontSize: 11, textTransform: 'uppercase', backgroundColor: '#4D7B52'  }} className="badge">R</span></td>)
                                                                    }
                                                                })()
                                                            }
                                                            {
                                                                (() => {
                                                                    switch (itemPeriodos.ESTADO_RECAUDO) {
                                                                        case 1:
                                                                            return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-primary">E</span></td>)
                                                                        case 2:
                                                                            return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-danger">PE</span></td>)
                                                                        case 3:
                                                                            return (<td><span style={{ fontSize: 11, textTransform: 'uppercase', backgroundColor: '#4D7B52' }} className="badge">R</span></td>)
                                                                        case 4:
                                                                            return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">P</span></td>)
                                                                        case 5:
                                                                            return (<td><span style={{ fontSize: 11, textTransform: 'uppercase', backgroundColor: '#66C77E' }} className="badge">PP</span></td>)
                                                                        default:
                                                                            return (<td></td>)
                                                                    }
                                                                })()
                                                            }
                                                            <td>
                                                                <div className="btn-group" role="group" aria-label="">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary btn-sm"
                                                                        data-bs-dismiss="modal"
                                                                        disabled={itemPeriodos.ESTADO_RECAUDO === null ? '' : true}
                                                                        onClick={() =>
                                                                            this.seleccionarPeriodo(itemPeriodos.ID_FACTURACION)
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Crear;